import Reflux from 'reflux';
import toogleHandlerActions from './toogleHandlerActions';

const ToogleStore = Reflux.createStore({
  listenables: toogleHandlerActions,
  onDropdownToogle(field) {
    this.trigger(field);
  },
});

export default ToogleStore;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/urlhandler/toogleHandlerStore.js
 **/